import React, { useState, useEffect } from 'react';
import './formulario.css';
import API from "../../providers/api";
import { Card, CardBody, Input, Button, Form, UncontrolledCollapse, Spinner } from "reactstrap"
import logo from '../../assets/img/logo.png'
import success from '../../assets/img/success.png'
import fail from '../../assets/img/fail.png'
import warning from '../../assets/img/warning.png'
import { alert } from '../../helpers/alert';
import moment from 'moment'
import md5 from 'md5';

const Confirmation = () => {
    useEffect(() => {
        API.guardarRegistroInscripcion(sessionStorage.getItem('arrayCompetidores'), "-", "-", "-", "-", "-", "-", "-", "-", "-", "-", "-", "-", "-", "-", "-", "-", "-", "-")
        .then(data => data.json())
        .then(dataJson => {
            console.log(dataJson)
        })
        .catch((e) => {
            console.log("Error =>", e)
        })
    }, [])

    return (
        <div className='flex-container'>
        </div>
    );
}

export default Confirmation;